import { Vector3 as o } from "three";
function e(n, r) {
  return n.clone().sub(new o(0.5, 0, 0.5)).applyQuaternion(r).add(new o(0.5, 0, 0.5)).round();
}
export {
  e as rotatePivot
};
//# sourceMappingURL=index24.js.map
